export enum ScanFieldTypeEnum {
  String = 1,
  Int = 2,
  Date = 3,
  Boolean = 4
}
